import React, { useEffect, useState } from "react";
import API from "../utils/api";
import { getLeagues } from "../services/leaguesService";

import "./Partners.css"; // فایل CSS


const NewsBox = () => {
  const [news, setNews] = useState([]);
  const [leagues, setLeagues] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pagination: 10 items per page, newest first
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;

  // Sort news by date (fall back to id if no date field)
  const sortedNews = React.useMemo(() => {
    return [...news].sort((a, b) => {
      const aDate = a.created_at || a.published_at || a.date;
      const bDate = b.created_at || b.published_at || b.date;
      if (aDate && bDate) return new Date(bDate) - new Date(aDate);
      if (a.id != null && b.id != null) return b.id - a.id;
      return 0;
    });
  }, [news]);

  const totalPages = Math.max(1, Math.ceil(sortedNews.length / pageSize));

  // if news updates, reset to first page
  useEffect(() => {
    setCurrentPage(1);
  }, [news]);

  // ensure currentPage is within bounds
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const displayedNews = sortedNews.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // دریافت اخبار
        const newsResponse = await API.get("/api/news/");
        setNews(newsResponse.data);

        // دریافت اطلاعات لیگ‌ها
        const leaguesList = await getLeagues();
        const leaguesData = leaguesList.reduce((acc, league) => {
          acc[league.id] = league.name; // تبدیل لیست به یک دیکشنری {id: name}
          return acc;
        }, {});
        setLeagues(leaguesData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("خطا در بارگذاری اطلاعات!");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p>در حال بارگذاری...</p>;
  if (error) return <p>{error}</p>;

  return (
    <section dir="rtl">
     

     <h3 className=" text-base p-4 text-white/80" style={{color: 'rgb(132, 204, 22)'}}>آخرین رویدادهای جشنواره</h3>
      <div className="flex flex-wrap m-4 text-right text-slate-400">
        {displayedNews.map((item) => (
          <div key={item.id} className="xl:w-1/3 md:w-1/2 p-4">
            <div className="bg-slate-900 p-6 rounded-lg">
              <img
                className="lg:h-60 xl:h-56 md:h-64 sm:h-72 xs:h-72 h-72 rounded w-full object-cover object-center mb-6"
                src={item.image} // فرض می‌کنیم API لینک تصویر را فراهم می‌کند
                alt={item.title}
              />
              <h3 className="tracking-widest text-indigo-500 text-xs font-medium title-font">
                {leagues[item.league] || "بدون لیگ"} {/* نام لیگ */}
              </h3>
              <h2 className="text-base text-slate-100 font-medium title-font mb-4">
                {item.title}
              </h2>
              <p className="leading-relaxed text-xs mb-4">
                {item.content.slice(0, 100)}... {/* نمایش خلاصه‌ای از محتوا */}
              </p>
              <a href={`news/${item.id}`} className="text-black bg-lime-400 hover:bg-lime-500 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">بیشتر بخوانید</a>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex items-center justify-center space-x-2 rtl:space-x-reverse mt-4">
          <button
            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            disabled={currentPage === 1}
            className="px-3 py-1 rounded bg-slate-700 text-slate-200 disabled:opacity-50"
          >
            قبلی
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              className={`px-3 py-1 rounded ${page === currentPage ? 'bg-lime-400 text-black' : 'bg-slate-700 text-slate-200'}`}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            disabled={currentPage === totalPages}
            className="px-3 py-1 rounded bg-slate-700 text-slate-200 disabled:opacity-50"
          >
            بعدی
          </button>
        </div>
      )}
    </section>
  );
};

const NewsBoxUser = ({ leagueID }) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!leagueID) return;
    const fetchUserNews = async () => {
      try {
        const response = await API.get(`/api/leagues/${leagueID}/news/`);
        console.log("Fetched user news:", response.data);
        let data = response.data;
        // اگر داده آرایه نیست، آن را در آرایه بپیچانیم
        if (!Array.isArray(data)) {
          data = [data];
        }
        setNews(data);
      } catch (err) {
        console.error("Error fetching user news:", err);
        
      } finally {
        setLoading(false);
      }
    };

    fetchUserNews();
  }, [leagueID]); // وابسته به leagueID

  if (loading) return <p>در حال بارگذاری اخبار لیگ {leagueID}...</p>;
  if (error) return <p>{error}</p>;
  if (news.length === 0) return <p>هنوز خبری موجود نیست.</p>;

  return (
    <section dir="rtl">
      <div className="flex items-center justify-between text-sm ">
        <h2 className="p-1 bg-slate-700 text-white">آخرین اخبار لیگ</h2>
        {/* <a className="text-lime-500 p-1" href="#">مشاهده همه</a> */}
      </div>
      <ul className="border-2 border-slate-300/70 rounded-md list-none p-0 max-h-[320px] overflow-y-auto">
        {news.map((item) => (
          <li key={item.id} className="hover:bg-white/5 transition-colors">
            <a href={`news/${item.id}`} className="flex p-2">
              <img
                src={`${process.env.REACT_APP_BACKEND_URL}${item.image}`}
                alt={item.title}
                className="w-10 h-10 rounded object-cover mx-2"
              />
              <div className="ml-4">
                <h2 className="text-slate-100 text-sm">{item.title}</h2>
                <p className="text-slate-400 text-xs">
                  {item.content?.slice(0, 50)}...
                </p>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export { NewsBoxUser };
export default NewsBox;

